// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';
// import cssVars from 'css-vars-ponyfill';

import '@/_axios';
import '@/_moment';

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import store from '@/store/index';
import App from '@/App';
import router from '@/router';
import VueNativeSock from 'vue-native-websocket';
import AlertsMixin from '@/mixins/AlertsMixin';

// todo
// cssVars()

Vue.use(BootstrapVue);
Vue.use(VueNativeSock, 'ws://localhost:12356', {
  format: 'json',
  reconnection: true,
  reconnectionDelay: 3000});
Vue.filter('translate', (value) => {
  const translations = store.state.Translations.translations.data;
  if (translations[value]) {
    return translations[value];
  }
  return value;
});

Vue.mixin(AlertsMixin);

Vue.prototype.$t = Vue.options.filters.translate;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  store
});